exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".users-card-element {\n  text-align: center;\n  width: 75vw;\n  padding: 5rem 7rem; }\n\nh1 {\n  text-transform: uppercase;\n  font-weight: 800;\n  font-size: 1em;\n  letter-spacing: .1em;\n  position: relative;\n  margin-bottom: 2rem; }\n  h1:after {\n    content: '';\n    display: block;\n    position: absolute;\n    width: 5rem;\n    border-bottom: 3px solid #4ab9b1;\n    margin-left: 50%;\n    -webkit-transform: translate(-50%);\n    transform: translate(-50%);\n    bottom: -1rem; }\n\nul {\n  list-style: none; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/components/users-card/users-card.component.scss
// module id = 191
// module chunks = 1